export const clone = {
  name: 'clone',
  template: (params) => {
    if (params.node.rowPinned) return null
    return `<a data-action='clone'
               xv-tooltip.bottom="'Duplicate'"
               data-name="'Duplicate'"
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               class='far fa-copy'>
            </a>`
  }
}

export const edit = {
  name: 'edit',
  template: (params) => {
    if (params.node.rowPinned) return null
    return `<a data-action='edit'
               xv-tooltip.bottom="'Edit'"
               data-name="'Edit'"
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               class='fas fa-pen'>
            </a>`
  }
}

export const remove = {
  name: 'remove',
  template: (params) => {
    if (params.node.rowPinned) return null
    return `<a data-action='remove'
               xv-tooltip.bottom="'Remove'"
               data-name="'Remove'"
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               class='fas fa-trash-alt'>
            </a>`
  }
}

export const externalEdit = (url) => ({
  name: 'externalEdit',
  template: (params) => {
    return `<a data-action='external-edit'
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               class='fas fa-pen'
               href='${url + (params.data && params.data[params.colDef.uid]) || 'javascript:;'}'>
            </a>`
  }
})

export const view = {
  name: 'view',
  template: (params) => {
    var target = params.newTab ? ' target = "_blank"' : ''

    return `<a class='dawn-button btn btn-actionbar'
               data-action='view'
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               ${target}
               href='${
                params.colDef.uri
                ? params.colDef.uri
                  .replace('{{env}}', global.app.api.env)
                  .replace('{{id}}', params.data && params.data[params.colDef.uid])
                  .replace('{{ProgramID}}', params.data && params.data['ProgramID'])
                : 'javascript:;'
                }'>
            ${params.colDef.label}
            </a>`
  }
}

export const goto = {
  name: 'goto',
  template: (params, ctx) => {
    var target = params.newTab ? ' target = "_blank"' : ''
    let tooltip = "(params.colDef.tooltip || 'Open {{text}}').replace('{{text}}', params.data && params.data[params.colDef.field])"
    let _env = ctx ? ctx.$root.api.env : ''
    let _screen = ctx ? ctx.screen : ''

    return `<a data-action='goto'
               v-tooltip.bottom="${tooltip}"
               data-name="${tooltip}"
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='params.data && params.data[params.colDef.uid]'
               ${target}
               :onclick='params.colDef.onclick'
               href="
                params.colDef.uri
                ? params.colDef.uri
                  .replace('{{env}}', '${_env}')
                  .replace('{{screen}}', '${_screen}')
                  .replace('{{id}}', params.data && params.data[params.colDef.uid])
                  .replace('{{ProgramID}}', params.data && params.data['ProgramID'])
                : 'javascript:;'
               ">
            ${params.value}
            </a>`
  }
}

export const gotoCustom = {
  name: 'gotoCustom',
  template: (params, ctx) => {
    var noTooltip = params.noTooltip ? params.noTooltip : false
    var target = params.newTab ? ' target = "_blank"' : ''
    let tooltip = (params.colDef.tooltip || 'Open {{text}}').replace('{{text}}', params.data && params.data[params.colDef.field])
    let _env = ctx ? ctx.$root.api.env : ''
    let _screen = ctx ? ctx.screen : ''

    let tooltipDirective = noTooltip ? '' : `v-tooltip.bottom="${tooltip}"`
    return `<a data-action='goto'
               ${tooltipDirective}
               data-name="${tooltip}"
               data-index='${params.node.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               ${target}
               :onclick='${params.colDef.onclick}'
               href="${params.colDef.uri
                ? params.colDef.uri
                  .replace('{{env}}', _env)
                  .replace('{{screen}}', _screen)
                  .replace('{{id}}', params.data && params.data[params.colDef.uid])
                  .replace('{{ProgramID}}', params.data && params.data['ProgramID'])
                : 'javascript:;'
              }">
            ${params.value}
            </a>`
  }
}

export const expand = {
  name: 'expand',
  template: (params) => {
    if (params.node.rowPinned) return null
    return `<a data-action='expand'
               v-tooltip.bottom="'Show/Hide Details'"
               data-name="'Show/Hide Details'"
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               class='fas fa-chevron-down'>
            </a>`
  }
}

export const drag = {
  name: 'drag',
  template: (params) => {
    if (params.node.rowPinned) return null
    return `<a data-action='drag'
               v-tooltip.bottom="'Move'"
               data-name="'Move'"
               data-index='${params.rowIndex}'
               data-key='${params.colDef.uid}'
               data-id='${params.data && params.data[params.colDef.uid]}'
               class='drag-handle'>
            </a>`
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/cells/actions.js